import { logError } from "common/error";
import "common/htmlComponents/blackScreen";
import "common/jquery-global";
import { load } from "common/loader";
import { delay, Waiter } from "common/promises";
import { ReesizeEventHandler } from "common/resize";
import { getSkip } from "common/skipper";
import { onVideoTime } from "common/video";
import { installVideoHighspeed, installVideoSpeedReset, } from "common/videoCheater";
import log from "loglevel";
import * as hi from "purs/Hi";
import { Context } from "./context";
import * as Opening from "./scene/1-opening/main";
import * as ChatBot from "./scene/2-chatbot/main";
import * as Announce from "./scene/3-announce/main";
import * as Video360 from "./scene/4-360video/main";
import "./scene/elements";
import "./scene/final/finishButton";
import * as firstInteraction from "./scene/interaction/1-run/main";
import * as secondInteraction from "./scene/interaction/2-king/main";
// import * as thirdInteraction from "./scene/interaction/3-dry-tear/main";
import * as fourthInteraction from "./scene/interaction/4-loveletter/main";
import * as fifthInteraction from "./scene/interaction/5-heart/main";
import * as sixthInteraction from "./scene/interaction/6-wreath/main";
import { loadingPaths, loadingSoundPath, openingSoundPath, } from "./scene/resources";
import * as loadingSound from "./scene/resources/loadingSound";
import * as openingSound from "./scene/resources/openingSound";
import { letterbox } from "./screen";
$(document).ready(async () => {
    try {
        console.log("version master videoduration - 7000");
        log.setLevel("debug");
        log.info(hi.hi);
        //    setSkipEvents();
        installVideoHighspeed();
        installVideoSpeedReset();
        if (window.innerWidth <= 600 || window.innerHeight <= 600) {
            $("body").addClass("ismobile");
        }
        if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) === false) {
            $("body").addClass("isdesktop");
        }
        const resizer = new ReesizeEventHandler();
        const urlParams = new URLSearchParams(window.location.search);
        const fromScene = urlParams.get("from");
        const context = new Context();
        letterbox(resizer);
        if (fromScene != null) {
            getSkip().skipAll();
        }
        // getSkip().skipScene = false;
        // getSkip().skipScene = false;
        // getSkip().skipDelay = false;
        log.info("start");
        log.trace("load opening sound file");
        const audioSrc = await loadOpeningSound();
        const loadLoading = loadLoadingResource();
        log.trace("load opening sound");
        const openingSound_ = await openingSound.loadSound(audioSrc);
        await waitUserInteractionForDev();
        log.info("start opening");
        await getSkip().asyncRunScene(() => Opening.start(openingSound_));
        log.trace("remove opening");
        $("jh-opening").remove();
        if (fromScene === "chatbot") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        log.info("start chatbot");
        await getSkip().asyncRunScene(() => ChatBot.start());
        if (fromScene === "announce") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        log.info("start announce");
        await getSkip().asyncRunScene(() => Announce.start());
        if (fromScene === "360video") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        const loadingSound_ = await loadLoading;
        log.info("start 360 video");
        const video360Result = await getSkip().asyncRunSceneOr(() => Video360.start(context, loadingSound_), () => Video360.skippedStart(context, fromScene === "before-run"));
        log.info("prepare first interaction");
        if (fromScene === "run" || fromScene === "before-run") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        const firstInterRet = await getSkip().asyncRunSceneOr(() => firstInteraction.start({
            context,
            input: video360Result,
        }), () => {
            let waitVideo = false;
            if (fromScene === "before-king") {
                getSkip().skipScene = false;
                getSkip().skipDelay = false;
                waitVideo = true;
            }
            return firstInteraction.skippedStart({
                context,
                input: video360Result,
                waitVideo,
            });
        });
        if (fromScene === "king") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        log.info("before king interaction");
        const secondInterRet = await getSkip().asyncRunSceneOr(() => secondInteraction.start({
            context,
            input: firstInterRet,
        }), () => {
            let waitVideo = false;
            if (fromScene === "before-loveletter") {
                getSkip().skipScene = false;
                getSkip().skipDelay = false;
                waitVideo = true;
            }
            return secondInteraction.skippedStart({
                context,
                input: firstInterRet,
                waitVideo,
            });
        });
        if (fromScene === "loveletter") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        log.info("before loveletter interaction");
        const fourthInterRet = await getSkip().asyncRunSceneOr(() => fourthInteraction.start({
            context,
            input: secondInterRet,
        }), () => {
            let waitVideo = false;
            if (fromScene === "before-heart") {
                getSkip().skipScene = false;
                getSkip().skipDelay = false;
                waitVideo = true;
            }
            return fourthInteraction.skippedStart({
                context,
                input: secondInterRet,
                waitVideo,
            });
        });
        if (fromScene === "heart") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        log.info("before heart interaction");
        const fifthInterRet = await getSkip().asyncRunSceneOr(() => fifthInteraction.start({
            context,
            input: fourthInterRet,
        }), () => {
            let waitVideo = false;
            if (fromScene === "before-wreath") {
                getSkip().skipScene = false;
                getSkip().skipDelay = false;
                waitVideo = true;
            }
            return fifthInteraction.skippedStart({
                context,
                input: fourthInterRet,
                waitVideo,
            });
        });
        if (fromScene === "wreath") {
            getSkip().skipScene = false;
            getSkip().skipDelay = false;
        }
        log.info("before wreath interaction");
        const sixthInterRet = await getSkip().asyncRunSceneOr(() => sixthInteraction.start({
            context,
            input: fifthInterRet,
        }), () => sixthInteraction.skippedStart({
            context,
            input: fifthInterRet,
        }));
        const { videoElem, progressElem } = await sixthInterRet.waiter.wait();
        progressElem.makeFadeOut();
        log.info("after wreath interaction");
        onVideoTime({
            videoElement: videoElem,
            timeMillis: (60 * 3 + 11) * 1000,
            callback: () => {
                log.info("show finish button");
                $("#resizer").append("<jh-finish-button></jh-finish-button>");
            },
        });
    }
    catch (e) {
        logError(e);
    }
});
async function loadLoadingResource() {
    await delay(1000);
    log.debug("load resources for loading");
    let audioSrc = "";
    await load({
        onProgress: () => null,
        onComplete: () => null,
        onAudio: (src) => (audioSrc = src),
        filePaths: [...loadingPaths, loadingSoundPath],
    });
    log.debug("loading audio src", audioSrc);
    return loadingSound.loadSound(audioSrc);
}
// This function does not need to be exported.
// To suupress ts6133 warning we made this be exported.
export function setSkipEvents() {
    const myShakeEvent = new Shake({
        threshold: 15,
        timeout: 1000,
    });
    myShakeEvent.start();
    window.addEventListener("shake", () => {
        log.debug("Shake");
        getSkip().toggleSkipDelay();
    }, false);
    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            log.debug("ESC");
            getSkip().toggleSkipDelay();
        }
    });
    $(document).on("touchstart", (evt) => {
        if (evt.touches.length > 2) {
            log.debug("multiple touch");
            getSkip().toggleSkipDelay();
        }
    });
}
async function loadOpeningSound() {
    let audioSrc = "";
    await load({
        onProgress: () => null,
        onComplete: () => null,
        onAudio: (src) => (audioSrc = src),
        filePaths: [openingSoundPath],
    });
    return audioSrc;
}
/**
 * 개발 중에는 전체 흐름의 중간부터 시작하므로 명시적으로 유저의 인터렉션을 받아야 한다.
 * 유저의 인터렉션이 있어야 사운드를 재생할 수 있기 때문이다.
 */
async function waitUserInteractionForDev() {
    if (getSkip().skipDelay) {
        const waiter = new Waiter();
        $(document).one("click", () => {
            waiter.trigger();
        });
        await waiter.wait();
        log.warn("Is unlocked?");
    }
}
//# sourceMappingURL=main.js.map